export { default } from "./GraficaProductosDia"
